// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3ixDy","form":"styles_form__3njsg","actions":"styles_actions__2fTJ8","button":"styles_button__3ztUy","loading":"styles_loading__1v5hP"};